import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, ExternalLink, CalendarClock } from 'lucide-react';
import PageShell from '@/components/PageShell';
import SEO from '@/components/SEO';
import { useLanguage } from '@/i18n/LanguageContext';
import { MCSO_JAIL, HOW_BAIL_WORKS_STEPS } from '@/data/siteContent';
import { track } from '@/lib/analytics';

const MontgomeryCountyJail = () => {
  const { lang, t } = useLanguage();
  return (
    <PageShell trackPage="/montgomery-county-jail">
      <SEO title="Montgomery County Jail Bail Bonds | Conroe, TX | Amigo's Bail Bonds" description="24/7 bail bonds for the Montgomery County Jail (Law Enforcement Center) in Conroe, TX. Fast, bilingual, confidential help — License #0111." path="/montgomery-county-jail" />
      <div className="page-hero">
        <div className="eyebrow"><MapPin size={13} style={{ verticalAlign: 'middle', marginRight: 4 }} />{MCSO_JAIL.address}</div>
        <h1 className="section-title">{lang === 'es' ? 'FIANZAS — CÁRCEL DEL CONDADO DE MONTGOMERY' : 'MONTGOMERY COUNTY JAIL BAIL BONDS'}</h1>
        <p className="section-subtitle" style={{ margin: '0 auto' }}>{lang === 'es' ? 'Ayuda rápida y confidencial las 24 horas para familias con un ser querido en esta instalación.' : 'Fast, confidential 24/7 help for families with a loved one at this facility.'}</p>
      </div>

      <section className="section section--void">
        <div className="container" style={{ maxWidth: 860 }}>
          <div className="card-grid card-grid--2 mb-8">
            <div className="info-card">
              <h3 style={{ color: 'var(--text-primary)', margin: '0 0 0.6rem' }}>{lang === 'es' ? 'Información de la instalación' : 'Facility Information'}</h3>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>{MCSO_JAIL.name}</p>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: '0.5rem' }}>{MCSO_JAIL.address}</p>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>{lang === 'es' ? 'Línea de información' : 'Info Line'}: <a href={`tel:${MCSO_JAIL.infoLine.replace(/\D/g, '')}`} style={{ color: 'var(--gold)' }}>{MCSO_JAIL.infoLine}</a></p>
            </div>
            <div className="info-card">
              <h3 style={{ color: 'var(--text-primary)', margin: '0 0 0.6rem' }}><CalendarClock size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} />{lang === 'es' ? 'Visitas y Búsqueda de Reclusos' : 'Visitation & Inmate Search'}</h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '0.7rem' }}>{lang === 'es' ? 'Las visitas requieren programación en línea con 24 horas de anticipación; no se aceptan visitas sin cita.' : 'Visits require online scheduling at least 24 hours in advance; walk-ins are not accepted.'}</p>
              <a href={MCSO_JAIL.inmateSearchUrl} target="_blank" rel="noopener noreferrer" className="btn-brass" onClick={() => track('jail_lookup_click', { location: 'mcj_page' })} data-testid="mcj-inmate-search-link">{t('common.locateInmate')} <ExternalLink size={14} /></a>
            </div>
          </div>

          <h2 className="section-title" style={{ fontSize: '1.6rem' }}>{lang === 'es' ? 'QUÉ ESPERAR' : 'WHAT TO EXPECT'}</h2>
          <div className="timeline mb-8">
            {HOW_BAIL_WORKS_STEPS.map((s, i) => (
              <div className="timeline-item" key={i}>
                <strong style={{ color: 'var(--text-primary)' }}>{s[lang].title}</strong>
                <p style={{ color: 'var(--text-secondary)', margin: '0.3rem 0 0' }}>{s[lang].text}</p>
              </div>
            ))}
          </div>

          <div className="urgent-strip" style={{ marginBottom: '2rem' }}>
            <p>{lang === 'es' ? '¿Su familiar está aquí ahora mismo?' : 'Is your loved one here right now?'}</p>
            <Link to="/start-a-bond" className="btn-brass" style={{ background: '#fff', color: 'var(--red)' }} data-testid="mcj-start-bond-cta">{t('hero.startBond')}</Link>
          </div>

          <div className="text-center">
            <a href="tel:9368282500" className="btn-red" data-testid="mcj-call-cta"><Phone size={16} /> {t('hero.callNow')}: (936) 828-2500</a>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default MontgomeryCountyJail;
